import { Route, Routes } from 'react-router-dom';

import { PatientCreationLayout } from '../layouts/PatientCreationLayout';
import { NotFound } from '../pages/errors/NotFound';
import OrderCase from '../pages/patient/CreationProcess/OderCase';
import UploadPatientPhotos from '../pages/patient/CreationProcess/UploadPatientPhotos';
import UploadPatientRadios from '../pages/patient/CreationProcess/UploadPatientRadios';
import UploadPatientStls from '../pages/patient/CreationProcess/UploadPatientStls';
import CaseType from '../pages/patient/CreationProcess/caseType';
import PatientDetails from '../pages/patient/CreationProcess/patientDetails';
import SubCaseType from '../pages/patient/CreationProcess/subCaseType';
import { ClientRoute } from './clientRoute';

export const PatientCreationRoutes = () => {
    return (
        <Routes>
            {/* Patient Creation Routes */}
            <Route
                path="/"
                element={
                    <ClientRoute>
                        <PatientCreationLayout>
                            <PatientDetails />
                        </PatientCreationLayout>
                    </ClientRoute>
                }
            />
            <Route
                path=":id/patient-details"
                element={
                    <ClientRoute>
                        <PatientCreationLayout>
                            <PatientDetails />
                        </PatientCreationLayout>
                    </ClientRoute>
                }
            />
            <Route
                path=":id/case-type"
                element={
                    <ClientRoute>
                        <PatientCreationLayout>
                            <CaseType />
                        </PatientCreationLayout>
                    </ClientRoute>
                }
            />
            <Route
                path=":id/sub-case-type"
                element={
                    <ClientRoute>
                        <PatientCreationLayout>
                            <SubCaseType />
                        </PatientCreationLayout>
                    </ClientRoute>
                }
            />

            <Route
                path=":id/tp-review"
                element={
                    <ClientRoute>
                        <PatientCreationLayout>
                            <UploadPatientRadios />
                        </PatientCreationLayout>
                    </ClientRoute>
                }
            />

            <Route
                path=":id/photos"
                element={
                    <ClientRoute>
                        <PatientCreationLayout>
                            <UploadPatientPhotos />
                        </PatientCreationLayout>
                    </ClientRoute>
                }
            />

            <Route
                path=":id/stls"
                element={
                    <ClientRoute>
                        <PatientCreationLayout>
                            <UploadPatientStls />
                        </PatientCreationLayout>
                    </ClientRoute>
                }
            />

            <Route
                path=":id/order"
                element={
                    <ClientRoute>
                        <PatientCreationLayout>
                            <OrderCase />
                        </PatientCreationLayout>
                    </ClientRoute>
                }
            />

            {/* 404 - Catch all unmatched routes */}
            <Route path="*" element={<NotFound />} />
        </Routes>
    );
};
